export default __webpack_public_path__ + "static/media/sobre_tablet1000.777a1374.webp";